import * as Arrows from './arrows';
import * as Cities from './cities';
import * as Countries from './countries';
import * as Devices24 from './devices-24';
import * as Devices40 from './devices-40';
import * as Extra from './extra';
import * as Files from './files';
import * as Financial from './financial';
import * as FoodAndDrink from './food-and-drinks';
import * as Hands from './hands';
import * as Interface from './interface';
import * as Leisure from './leisure';
import * as LocationsAndTransport from './locations-and-transport';
import * as Other from './other';
import * as Products from './products';
import * as ProductsAndFeatures from './products-and-features';
import * as Shapes from './shapes';
import * as Team from './team';
import * as UiAndPeople from './ui-and-people';
import * as Various from './various';

export default {
    Arrows,
    Cities,
    Countries,
    Devices24,
    Devices40,
    Extra,
    Files,
    Financial,
    FoodAndDrink,
    Hands,
    Interface,
    Leisure,
    LocationsAndTransport,
    Other,
    Products,
    ProductsAndFeatures,
    Shapes,
    Team,
    UiAndPeople,
    Various
};
